import PropTypes from 'prop-types';
import React from 'react';
import Text from '@jd/jmtd/es/Text';
export default function SummaryCardIndex(_ref) {
  var children = _ref.children,
      right = _ref.right;
  return /*#__PURE__*/React.createElement("div", {
    className: "jmtp-summary-card-index"
  }, right ? /*#__PURE__*/React.createElement("div", {
    className: "jmtp-summary-card-index-main"
  }, children) : children, right && /*#__PURE__*/React.createElement("div", {
    className: "jmtp-summary-card-index-right"
  }, /*#__PURE__*/React.createElement(Text, null, right)));
}
SummaryCardIndex.propTypes = {
  children: PropTypes.node,
  right: PropTypes.node
};
SummaryCardIndex.defaultProps = {
  children: null,
  right: null
};